<!-- Header -->
<div>
	<div mat-dialog-title style="display: inline-block">
		<span translate>Register New Family</span>
	</div>
	<div style="float:right;padding:15px;font-weight:400;color:#E8EAF6">
		<span translate>Step 1 of 5</span>
	</div>
</div>

<!-- Body -->
<mat-dialog-content>
	<div translate>Please provide your email address, then select Next.</div>

	<!-- We have a margin-bottom of 1px because of a weird issue with a scrollbar -->
	<tyl-form-field style="width:350px; padding-top: 10px; margin-bottom: 1px;" label="Email Address">
		<input matInput id="inputEmailAddress" name="inputEmailAddress" [maxlength]="V10 == true ? 500 : 75"
			[(ngModel)]="registerNewFamily.emailAddress" emailFormat #email />
	</tyl-form-field>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left"></div>

	<!-- Right -->
	<div class="flex-footer-right">
		<error-prompt [errorList]="errorList"> </error-prompt>
		<tyl-button image="previous arrow.png" label="Previous" (clickEvent)="modalInstancePreviousClick()">
		</tyl-button>
		<tyl-button image="next arrow yellow.png" label="Next" (clickEvent)="modalInstanceNextClick()"></tyl-button>
		<tyl-button image="Cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>
	</div>
</mat-dialog-actions>

<!-- Old Code -->
<!--<div class="popup" #dialogWindow>-->
<!--<div class="modal-header">-->
<!--<div class="modal-headerTitle" style="padding-left:10px;padding-top:10px;display:inline-block" translate>Register New Family</div>-->
<!--<div style="float:right;padding:15px;font-weight:400;color:#8f9b49">Step 1 of 5</div>-->
<!--</div>-->
<!--<mat-dialog-content style="width: 100%">-->
<!--<div translate>Please provide your email address, then select Next.</div>-->
<!--&lt;!&ndash; We have a margin-bottom of 1px because of a weird issue with a scrollbar &ndash;&gt;-->
<!--<tyl-form-field style="width:350px; padding-top: 10px; margin-bottom: 1px;"-->
<!--label="Email Address">-->
<!--<input matInput-->
<!--id="inputEmailAddress"-->
<!--name="inputEmailAddress"-->
<!--[(ngModel)]="registerNewFamily.emailAddress"-->
<!--emailFormat-->
<!--#email/>-->
<!--</tyl-form-field>-->
<!--</mat-dialog-content>-->
<!--<mat-dialog-actions style="position: sticky">-->
<!--<div class="footerRight">-->
<!--<error-prompt [errorList]="errorList"> </error-prompt>-->
<!--<tyl-button image="previous arrow.png" label="Previous" (clickEvent)="modalInstancePreviousClick()"></tyl-button>-->
<!--<tyl-button image="next arrow yellow.png" label="Next" (clickEvent)="modalInstanceNextClick()"></tyl-button>-->
<!--<tyl-button image="Cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>-->
<!--</div>-->
<!--</mat-dialog-actions>-->
<!--</div>-->